module.exports = __webpack_public_path__ + "img/member_message_icon_431006.69b1f43b.png";